<template>
  <v-container id="selectorlocalidadv3-caplp">
    <v-row class="text-center">
      <v-col cols="12" md="10" lg="10">
        <v-text-field
            v-model="locsel.localidacompleta"
            label="Localidad"
            height="20px"
            readonly
        />
      </v-col>
      <v-col cols="12" md="1" lg="1">
        <v-btn
          class="ma-2"
          fab
          dark
          x-small
          color="primary"
          title="Buscar"
          @click="BuscarLocalidad"
        >
          <v-icon dark> mdi-magnify </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogsellocalidad" persistent max-width="800">
      <v-card min-height="400">
        <v-card-title class="headline">
          Seleccionar Localidad
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn
                color="red darken-1"
                text
                @click="dialogsellocalidad = false"
              >
                Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <br/>
          <br/>
          <v-row row wrap>
            <v-col cols="12" md="4" lg="4">
              <v-select
                v-model="filtro.idprovincia"
                :items="listaprovincias"
                label="Provincia"
                item-text="provincia"
                item-value="idprovincia"
                height="20px"
                v-on:change="actualizagrillaloc(false)"
              />
            </v-col>
            <v-col cols="12" md="8" lg="8">
              <v-select
                v-model="filtro.iddepto"
                :items="listadepartamentos"
                label="Depto/Partido"
                item-text="nombre"
                item-value="iddepartamento"
                height="20px"
                v-on:change="actualizagrillaloc(false)"
              />
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12">
              <v-data-table
                :headers="columnasgrilla"
                :items="listagrilla"
                :search="nombre"
                :items-per-page="10"
                :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                }"
                class="elevation-1"
                dense
                no-data-text="Sin Registros"
                multi-sort
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="seleccionarlocalidad(item)">
                      mdi-arrow-right
                    </v-icon>
                  </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="dialogmensaje = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "@/axios";
export default {
  data() {
    return {
      loading: false,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      listaprovincias: [],
      listadepartamentos: [],
      filtro: {
        idlocalidad: 0,
        idprovincia: 0,
        iddepto: 0
      },
      dialogsellocalidad: false,
      locsel: {
        idlocalidad: 0,
        localidad: '',
        iddepto: 0,
        depto: '',
        idprov: 0,
        prov: ''
      },
      columnasgrilla: [
        {
          text: "Op.",
          value: "actions",
          align: "center",
          width: 20,
        },
        {
          text: "ID",
          align: "left",
          sortable: true,
          value: "idlocalidad",
          width: 70,
        },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "localidad",
          width: 120,
        },
        {
          text: "Depto/Partido",
          align: "left",
          sortable: true,
          value: "depto",
          width: 120,
        },
        {
          text: "Provincia",
          align: "left",
          sortable: true,
          value: "provincia",
          width: 100,
        },
        {
          text: "Circunsc.",
          align: "left",
          sortable: true,
          value: "circunscripcion",
          width: 100,
        }
      ],
      listagrilla: []
    };
  },
  props: ["idlocinicial","idprovinicial","iddeptoinicial"],
  mounted() {
    if ((this.idlocinicial != null && this.idlocinicial != "" && this.idlocinicial > 0) 
      ||  (this.idprovinicial != null && this.idprovinicial != "" && this.idprovinicial > 0)
      ||  (this.iddeptoinicial != null && this.iddeptoinicial != "" && this.iddeptoinicial > 0)
    ){
      this.buscalocdirecto();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.dialogmensaje = true;
    },
    BuscarLocalidad () {
      axios.get("provincia").then((result) => {
        this.listaprovincias = result.data;
        this.listaprovincias.unshift({idprovincia: 0, provincia: '(TODAS)'});
        if (this.idprovinicial != null && this.idprovinicial != "" && this.idprovinicial > 0) {
          this.filtro.idprovincia= this.idprovinicial;
        }else{
          this.filtro.idprovincia= 42;
        }
        axios.get("referenciales/departamentos").then((result) => {
          this.listadepartamentos = result.data.filter(d=> d.idprovincia==this.filtro.idprovincia);
          this.listadepartamentos.unshift({iddepartamento: 0, nombre: '(TODOS)', idprovincia: 0, provincia: '(TODAS)'});
          if (this.iddeptoinicial != null && this.iddeptoinicial != "" && this.iddeptoinicial > 0) {
            this.filtro.iddepto= this.iddeptoinicial;
          }else{
            this.filtro.iddepto= 395;
          }
          this.filtro.idlocalidad= 0;
          this.actualizagrillaloc(true);
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error);
        });
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error);
      });
    },
    actualizagrillaloc (abrirdialog) {
      this.loading=true;
      var filtros= JSON.stringify(this.filtro);
      axios.post("localidad/PostListaLocalidades", filtros, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.listagrilla = result.data.datos;
          if(abrirdialog){
            this.dialogsellocalidad= true;
          }
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    seleccionarlocalidad (item) {
      this.loading = true;
      this.locsel= {
        idlocalidad: item.idlocalidad,
        localidad: item.localidad,
        iddepto: item.iddepto,
        depto: item.depto,
        idprov: item.idprovincia,
        prov: item.provincia,
        localidacompleta: item.idprovincia!=null ? item.idlocalidad.toString()+' - '+item.localidad + ' (' + item.provincia + ')' : item.idlocalidad.toString()+' - '+item.localidad
      };
      this.$emit("selLocalidad", item);
      this.dialogsellocalidad = false;
      this.loading = false;
    },
    buscalocdirecto () {
      this.loading=true;
      this.filtro.idlocalidad= this.idlocinicial;
      this.filtro.idprovincia= 0;
      this.filtro.iddepto= 0;
      var filtros= JSON.stringify(this.filtro);
      axios.post("localidad/PostListaLocalidades", filtros, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          var item= result.data.datos[0];
          this.locsel= {
            idlocalidad: item.idlocalidad,
            localidad: item.localidad,
            iddepto: item.iddepto,
            depto: item.depto,
            idprov: item.idprovincia,
            prov: item.provincia,
            localidacompleta: item.idprovincia!=null ? item.idlocalidad.toString()+' - '+item.localidad + ' (' + item.provincia + ')' : item.idlocalidad.toString()+' - '+item.localidad
          };
          this.$emit("selLocalidad", item);
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    }
  },
  watch: {
    idlocinicial: function (val) {
      if (val != null && val != "") {
        this.buscalocdirecto();
      }
    },
    idprovinicial: function (val) {
      if (val != null && val != "") {
        this.buscalocdirecto();
      }
    },
    iddeptoinicial: function (val) {
      if (val != null && val != "") {
        this.buscalocdirecto();
      }
    }
  }
};
</script>
<style>
</style>